import script from "./projectList.vue?vue&type=script&setup=true&lang=ts"
export * from "./projectList.vue?vue&type=script&setup=true&lang=ts"

import "./projectList.vue?vue&type=style&index=0&id=6495709e&scoped=true&lang=scss"
import "./projectList.vue?vue&type=style&index=1&id=6495709e&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6495709e"]])

export default __exports__